module.exports = __webpack_public_path__ + "static/media/BO2A9941.12d8170c.jpg";